window.Login = {
    $win: $(window),
    $pageContainer: $('.login-register-page'),

    modalTimer: 0,

    init: function () {
        var self = this;

        if (!self.$pageContainer.length) {
            return;
        }
        
        self.initLogin();
    },

    initLogin: function () {
        var form = $('.login-block #login-form');
        var loginAction = form.data('login-action');
        var forgotPasswordAction = form.data('forgot-password-action');

        $('#forgot-password-link').click(function (e) {
            e.preventDefault();
            $('.login-block').addClass("forgot-password");
            form.attr('action', forgotPasswordAction);
        });
        $('#back-to-login-link').click(function (e) {
            e.preventDefault();
            $('.login-block').removeClass("forgot-password");
            form.attr('action', loginAction);
        });
    },

    loginComplete: function (result) {
        if (result.Success) {
            window.location.href = result.ReturnUrl;
        }
        else {
            $('#login-form .validationText').html(result.ResponseMessage);
        }
    },
    requestResetComplete: function (result) {
        if (result.Success) {
            $('#request-reset-form').addClass('success');
            $('#request-reset-form .message').html(result.ResponseMessage);
            $('#request-reset-form .validationText').html('');
        }
        else {
            $('#request-reset-form .message').html('');
            $('#request-reset-form .validationText').html(result.ResponseMessage);
        }
    },
    resetPasswordComplete: function (result) {
        if (result.Success) {
            $('#new-password-form').addClass('success');
            $('#new-password-form .message').html(result.ResponseMessage);
            $('#new-password-form .validationText').html('');
        }
        else {
            $('#new-password-form .validationText').html(result.ResponseMessage);
            $('#new-password-form .message').html('');
        }
    },
     registerComplete: function (result) {
        if (result.Success) {
            $('#register-form .successMessage').html(result.ResponseMessage);
        }
        else {
            $('#register-form .validationText').html(result.ResponseMessage);
        }
    }
};
